module.exports = __webpack_public_path__ + "static/img/Group 68.1d7c8699.png";